import { takeEvery, takeLatest } from "redux-saga/effects";
import * as actions from "./actions";
import { 
  changePassword,
  finalizeReset, 
  login, 
  reset } from "./sagas/auth";
import {
  createUserInOrg,
  createUserWithOrg,
  getOrganizationUsers,
  getOrganizations,
  setOrganization,
} from "./sagas/organizations";
import {
  attachUser,
  changeUserRole,
  createDashAndAssignToMeasurable,
  createScenario,
  createScenarioMeasurable,
  createUser,
  createWorkspace,
  detachUser,
  getScenarioMeasurables,
  getWorkspace,
  getWorkspaces,
  setCurrentWorkspace,
  updateScenario,
  updateScenarioMeasurable,
} from "./sagas/workspaces";
import {
  //cloneDash,
  assignCodeProposal,
  createDash,
  deleteDash,
  //getDocumentImagePreview,
  getCodeComments,
  getCodeProposals,
  getDashes,
  moveDash,
  updateDash,
  updateDashFile,
} from "./sagas/dashes";

import {
  backFolder,
  changeFolder,
  createFolder,
  deleteFolder,
  getFolders,
} from "./sagas/folders";

import {
  createRole,
  getRoles,
  getUsersInRole,
  linkDashToRole,
  linkFolderToRole,
  linkRole,
  unlinkRole,
} from "./sagas/roles";

import {
  codeSearch,
  commitRepo,
  createRepo,
  createRepoFile,
  createRepoFolder,
  deleteFile,
  expandNetworkCallers,
  expandNetworkFile,
  expandNetworkFunction,
  expandNetworkSlice,
  showNetworkCode,
  fileList,
  getFeatureSlice,
  getFunctionCallees,
  getLineCounts,
  getRepos,
  getReverseSlice,
  gitInfo,
  indexRepoBackground,
  loadFileGraph,
  loadGraphSettings,
  mapFile,
  openFile,
  pollIndexStatus,
  pullRepo,
  pushRepo,
  renameFile,
  saveGraphSettings,
  setFolderLabel,
} from "./sagas/repos";

import {
  createRepoFileWithContent,
} from "./sagas/business_logics";

import {
  createHost,
  getHosts,
  resetHostPassword,
  updateHost,
} from "./sagas/hosts";

import {
  createFactotum,
  createFactotumState,
  createFactotumStateTie,
  getFactotumStateTies,
  getFactotumStates,
  getFactotums,
  updateFactotum,
  updateFactotumState,
} from "./sagas/factotums";

import {
  createProject,
  createProjectTask,
  createProjectTaskInput,
  deleteProjectTaskInput,
  getProjectTask,
  getProjectTasks,
  getProjects,
  toggleProjectTaskInput,
  updateProject,
  updateProjectTask,
  updateProjectTaskInput,
} from "./sagas/projects";

import {
  createAutoLine,
  createAutomation,
  getAutoLines,
  getAutomations,
  runAutomation,
  updateAutoLine,
  updateAutomation,
} from "./sagas/automations";


import {
  createBookmark,
} from "./sagas/bookmarks";

import {
  loadIdeState,
  saveIdeState,
} from "./sagas/ide";

import {
  attachChart,
  createApiCall,
  createChart,
  createChartAboveChart,
  createDataTable,
  createDataTableColumn,
  createDataTableRow,
  createNavigation,
  createParameter,
  deleteChart,
  executeApiCall,
  executeChartCode,
  setEditingDash,
  setEditingDataTable,
  setPageNoSaga,
  switchCharts,
  updateApiCall,
  updateChart,
  updateChartCode,
} from "./sagas/editor";

export function* rootSaga() {
  yield takeLatest(actions.login.type, login);
  yield takeLatest(actions.reset.type, reset);
  yield takeLatest(actions.finalizeReset.type, finalizeReset);
  yield takeLatest(actions.changePassword.type, changePassword);
  yield takeLatest(actions.getOrganizations.type, getOrganizations);
  yield takeLatest(actions.setOrganization.type, setOrganization);
  yield takeLatest(actions.getOrganizationUsers.type, getOrganizationUsers);

  yield takeLatest(actions.getWorkspace.type, getWorkspace);
  yield takeLatest(actions.getWorkspaces.type, getWorkspaces);

  yield takeLatest(actions.setWorkspace.type, setCurrentWorkspace);
  yield takeLatest(actions.createWorkspace.type, createWorkspace);
  yield takeLatest(actions.attachUser.type, attachUser);
  yield takeLatest(actions.createUser.type, createUser);
  yield takeLatest(actions.createUserInOrg.type, createUserInOrg);
  yield takeLatest(actions.createUserWithOrg.type, createUserWithOrg);
  yield takeLatest(actions.detachUser.type, detachUser);
  yield takeLatest(actions.changeUserRole.type, changeUserRole);


  yield takeLatest(actions.getDashes.type, getDashes);
  yield takeLatest(actions.getCodeProposals.type, getCodeProposals);
  yield takeLatest(actions.getCodeComments.type, getCodeComments);
  yield takeLatest(actions.assignCodeProposal.type, assignCodeProposal);
  yield takeLatest(actions.createDash.type, createDash);

  yield takeLatest(actions.getFolders.type, getFolders);
  yield takeLatest(actions.createFolder.type, createFolder);
  yield takeLatest(actions.changeFolder.type, changeFolder);
  yield takeLatest(actions.backFolder.type, backFolder);

  yield takeLatest(actions.getRoles.type, getRoles);
  yield takeLatest(actions.getUsersInRole.type, getUsersInRole);
  yield takeLatest(actions.createRole.type, createRole);
  yield takeLatest(actions.linkRole.type, linkRole);
  yield takeLatest(actions.unlinkRole.type, unlinkRole);
  yield takeLatest(actions.linkDashToRole.type, linkDashToRole);
  yield takeLatest(actions.linkFolderToRole.type, linkFolderToRole);
  
  yield takeLatest(actions.getRepos.type, getRepos);
  yield takeLatest(actions.getHosts.type, getHosts);
  yield takeLatest(actions.getFactotums.type, getFactotums);
  yield takeLatest(actions.getAutomations.type, getAutomations);
  yield takeLatest(actions.createRepo.type, createRepo);
  yield takeLatest(actions.createScenario.type, createScenario);
  yield takeLatest(actions.updateScenario.type, updateScenario);
  yield takeLatest(actions.createScenarioMeasurable.type, createScenarioMeasurable);
  yield takeLatest(actions.createDashAndAssignToMeasurable.type, createDashAndAssignToMeasurable);
  yield takeLatest(actions.updateScenarioMeasurable.type, updateScenarioMeasurable);
  yield takeLatest(actions.getScenarioMeasurables.type, getScenarioMeasurables);
  yield takeLatest(actions.createHost.type, createHost);
  yield takeLatest(actions.updateHost.type, updateHost);
  yield takeLatest(actions.resetHostPassword.type, resetHostPassword);
  yield takeLatest(actions.createFactotum.type, createFactotum);
  yield takeLatest(actions.updateFactotum.type, updateFactotum);
  yield takeLatest(actions.getFactotumStates.type, getFactotumStates);
  yield takeLatest(actions.createFactotumState.type, createFactotumState);
  yield takeLatest(actions.updateFactotumState.type, updateFactotumState);
  yield takeLatest(actions.getFactotumStateTies.type, getFactotumStateTies);
  yield takeLatest(actions.createFactotumStateTie.type, createFactotumStateTie);
  yield takeLatest(actions.getProjects.type, getProjects);
  yield takeLatest(actions.getProjectTasks.type, getProjectTasks);
  yield takeLatest(actions.createProjectTask.type, createProjectTask);
  yield takeLatest(actions.updateProjectTask.type, updateProjectTask);
  yield takeLatest(actions.getProjectTask.type, getProjectTask);
  yield takeLatest(actions.createProjectTaskInput.type, createProjectTaskInput);
  yield takeLatest(actions.toggleProjectTaskInput.type, toggleProjectTaskInput);
  yield takeLatest(actions.updateProjectTaskInput.type, updateProjectTaskInput);
  yield takeLatest(actions.deleteProjectTaskInput.type, deleteProjectTaskInput);
  yield takeLatest(actions.createProject.type, createProject);
  yield takeLatest(actions.updateProject.type, updateProject);
  yield takeLatest(actions.createAutomation.type, createAutomation);
  yield takeLatest(actions.updateAutomation.type, updateAutomation);
  yield takeLatest(actions.createAutoLine.type, createAutoLine);
  yield takeLatest(actions.getAutoLines.type, getAutoLines);
  yield takeLatest(actions.updateAutoLine.type, updateAutoLine);
  yield takeLatest(actions.runAutomation.type, runAutomation);
  yield takeLatest(actions.createBookmark.type, createBookmark);

  // IDE browser state
  yield takeLatest(actions.saveIdeState.type, saveIdeState);
  yield takeLatest(actions.loadIdeState.type, loadIdeState);
  yield takeLatest(actions.pullRepo.type, pullRepo);
  yield takeLatest(actions.commitRepo.type, commitRepo);
  yield takeLatest(actions.pushRepo.type, pushRepo);
  yield takeLatest(actions.fileList.type, fileList);
  yield takeLatest(actions.codeSearch.type, codeSearch);
  yield takeLatest(actions.setFolderLabel.type, setFolderLabel);
  yield takeLatest(actions.getLineCounts.type, getLineCounts);
  yield takeLatest(actions.mapFile.type, mapFile);
  yield takeLatest(actions.getFunctionCallees.type, getFunctionCallees);
  yield takeLatest(actions.getFeatureSlice.type, getFeatureSlice);
  yield takeLatest(actions.getReverseSlice.type, getReverseSlice);
  yield takeLatest(actions.loadFileGraph.type, loadFileGraph);
  yield takeLatest(actions.indexRepoBackground.type, indexRepoBackground);
  yield takeLatest(actions.pollIndexStatus.type, pollIndexStatus);
  yield takeEvery(actions.expandNetworkFile.type, expandNetworkFile);
  yield takeEvery(actions.expandNetworkFunction.type, expandNetworkFunction);
  yield takeEvery(actions.expandNetworkCallers.type, expandNetworkCallers);
  yield takeEvery(actions.expandNetworkSlice.type, expandNetworkSlice);
  yield takeEvery(actions.showNetworkCode.type, showNetworkCode);
  yield takeLatest(actions.loadGraphSettings.type, loadGraphSettings);
  yield takeLatest(actions.saveGraphSettings.type, saveGraphSettings);
  yield takeLatest(actions.gitInfo.type, gitInfo);
  yield takeLatest(actions.openFile.type, openFile);
  yield takeLatest(actions.deleteFile.type, deleteFile);
  yield takeLatest(actions.renameFile.type, renameFile);
  yield takeLatest(actions.createRepoFile.type, createRepoFile);
  yield takeLatest(actions.createRepoFileWithContent.type, createRepoFileWithContent);
  yield takeLatest(actions.createRepoFolder.type, createRepoFolder);

  yield takeLatest(actions.updateDash.type, updateDash);
  yield takeLatest(actions.updateDashFile.type, updateDashFile);
  yield takeLatest(
    actions.setEditingDash.type,
    setEditingDash
  );
  yield takeLatest(
    actions.setEditingDataTable.type,
    setEditingDataTable
  );
  // NOTE: We are taking every instance as this can be fired in batches.
  // yield takeEvery(
  //  actions.getDocumentImagePreview.type,
  // getDocumentImagePreview
  //);

  
  yield takeLatest(actions.deleteDash.type, deleteDash);
  yield takeLatest(actions.deleteFolder.type, deleteFolder);
  //yield takeLatest(actions.cloneDash.type, cloneDash);
  yield takeLatest(actions.moveDash.type, moveDash);

  yield takeLatest(actions.createChart.type, createChart);
  yield takeLatest(actions.createNavigation.type, createNavigation);
  yield takeLatest(actions.createApiCall.type, createApiCall);
  yield takeLatest(actions.executeApiCall.type, executeApiCall);
  yield takeLatest(actions.updateApiCall.type, updateApiCall);
  yield takeLatest(actions.createDataTable.type, createDataTable);
  yield takeLatest(actions.createDataTableColumn.type, createDataTableColumn);
  yield takeLatest(actions.createDataTableRow.type, createDataTableRow);
  yield takeLatest(actions.createParameter.type, createParameter);
  yield takeLatest(actions.setPageNo.type, setPageNoSaga);
  yield takeLatest(actions.attachChart.type, attachChart);
  yield takeLatest(actions.updateChart.type, updateChart);
  yield takeLatest(actions.updateChartCode.type, updateChartCode);
  yield takeLatest(actions.executeChartCode.type, executeChartCode);
  yield takeLatest(
    actions.createChartAboveChart.type,
    createChartAboveChart
  );
  yield takeLatest(actions.switchCharts.type, switchCharts);
  yield takeLatest(actions.deleteChart.type, deleteChart);



  //yield takeLatest(
  //  actions.uploadDocumentElementImage.type,
  //  uploadDocumentElementImage
  //);

}
